import { c as _c } from "react/compiler-runtime";
import type { ApiWave } from "@/generated/models/ApiWave";
import { ApiWaveCreditType } from "@/generated/models/ApiWaveCreditType";
import WaveRatingCardSetTdh from "./WaveRatingCardSetTdh";
import WaveRatingRep from "./WaveRatingRep";
const CREDIT_TYPE_LABELS: Record<ApiWaveCreditType, string> = {
  [ApiWaveCreditType.Tdh]: "TDH",
  [ApiWaveCreditType.Xtdh]: "XTDH",
  [ApiWaveCreditType.TdhPlusXtdh]: "TDH + XTDH",
  [ApiWaveCreditType.Rep]: "REP",
  [ApiWaveCreditType.CardSetTdh]: "Card Set TDH"
};
interface WaveRatingProps {
  readonly wave: ApiWave;
}
export default function WaveRating(t0) {
  const $ = _c(10);
  const {
    wave
  } = t0;
  const creditType = wave.voting.credit_type;
  if (creditType === ApiWaveCreditType.CardSetTdh) {
    let t1;
    if ($[0] !== wave.voting.credit_nfts) {
      t1 = <WaveRatingCardSetTdh creditNfts={wave.voting.credit_nfts} />;
      $[0] = wave.voting.credit_nfts;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  const t1 = CREDIT_TYPE_LABELS[creditType];
  let t2;
  if ($[2] !== t1) {
    t2 = <span className="tw-self-end tw-font-medium tw-text-iron-200">{t1}</span>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== creditType || $[5] !== wave) {
    t3 = creditType === ApiWaveCreditType.Rep && <WaveRatingRep wave={wave} />;
    $[4] = creditType;
    $[5] = wave;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className="tw-flex tw-w-full tw-flex-col tw-items-end tw-gap-2 tw-text-sm">{t2}{t3}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}